export const songsEn = [
  {
    stage: 1,
    quizInfo: [
      {
        id: 1,
        name: 'Q_BillieEilish_BadGuy',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_BillieEilish_BadGuy.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/BillieEilish_BadGuy.mp3',
        correctSinger: {
          song: 'Billie Eilish',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Angelina Jolie',
          },
          {
            song: 'Steve Jobs',
          },
          {
            song: 'James Cameron',
          },
          {
            song: 'Sherlock Holmes',
          },
          {
            song: 'Michael Jordan',
          },
          {
            song: 'Luc Besson',
          },
        ],
      },
      {
        id: 2,
        name: 'Q_HarryStyles_AsItWas',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_HarryStyles_AsItWas.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/HarryStyles_AsItWas.mp3',
        correctSinger: {
          song: 'Harry Styles',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Drowning Pool',
          },
          {
            song: 'Fall Out Boy',
          },
          {
            song: 'Linkin Park',
          },
          {
            song: 'Muse',
          },
          {
            song: 'ASKING ALEXANDRIA',
          },
          {
            song: 'Limp Bizkit',
          },
        ],
      },
      {
        id: 3,
        name: 'Q_Adele_EasyOnMe',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_Adele_EasyOnMe.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Adele_EasyOnMe.mp3',
        correctSinger: {
          song: 'Adele',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Metallica',
          },
          {
            song: 'Disturbed',
          },
          {
            song: 'Muse',
          },
          {
            song: 'Deftones',
          },
          {
            song: 'Slipknot',
          },
          {
            song: 'Stone Sour',
          },
        ],
      },
      {
        id: 4,
        name: 'Q_OliviaRodrigo_Good4u',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_OliviaRodrigo_Good4u.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/OliviaRodrigo_Good4u.mp3',
        correctSinger: {
          song: 'Olivia Rodrigo',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Five Finger Death Punch',
          },
          {
            song: 'Pantera',
          },
          {
            song: 'Breaking Benjamin',
          },
          {
            song: 'Linkin Park',
          },
          {
            song: 'Disturbed',
          },
          {
            song: 'Billy Talent',
          },
        ],
      },
      {
        id: 5,
        name: 'Q_Gayle_Abcdefu',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_Gayle_Abcdefu.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Gayle_Abcdefu.mp3',
        correctSinger: {
          song: 'Gayle',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Queen',
          },
          {
            song: 'Imagine Dragons',
          },
          {
            song: 'twenty one pilots',
          },
          {
            song: "Guns N' Roses",
          },
          {
            song: 'Arctic Monkeys',
          },
          {
            song: 'Led Zeppelin',
          },
        ],
      },
    ],
  },
  {
    stage: 2,
    quizInfo: [
      {
        id: 1,
        name: 'Q_RihannaFeatJAYZ_Umbreella',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_RihannaFeatJAYZ_Umbreella.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/RihannaFeatJAYZ_Umbreella.mp3',
        correctSinger: {
          song: 'Rihanna feat. JAY Z',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Adele',
          },
          {
            song: 'AronChupa / Little Sis Nora',
          },
          {
            song: 'Imagine Dragons',
          },
          {
            song: 'Katy Perry',
          },
          {
            song: 'Taylor Swift',
          },
          {
            song: 'MGMT',
          },
        ],
      },
      {
        id: 2,
        name: 'Q_EdSheeran_ShapeOfYou',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_EdSheeran_ShapeOfYou.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/EdSheeran_ShapeOfYou.mp3',
        correctSinger: {
          song: 'Ed Sheeran',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Bruno Mars',
          },
          {
            song: 'Britney Spears',
          },
          {
            song: 'Olivia Rodrigo',
          },
          {
            song: 'Taylor Swift',
          },
          {
            song: 'Timbaland ft. OneRepublic',
          },
          {
            song: 'Daft Punk feat. P. Williams / N. Rodgers',
          },
        ],
      },
      {
        id: 3,
        name: 'Q_DaftPunkPharrellWilliamsNileRodgers_GetLucky',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_DaftPunkPharrellWilliamsNileRodgers_GetLucky.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/DaftPunkPharrellWilliamsNileRodgers_GetLucky.mp3',
        correctSinger: {
          song: 'Daft Punk feat. P. Williams / N. Rodgers',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Wiz Khalifa ft. Charlie Puth',
          },
          {
            song: 'Glass Animals',
          },
          {
            song: 'Gotye feat. Kimbra',
          },
          {
            song: 'Adele',
          },
          {
            song: 'Fun. ft. Janelle Monáe',
          },
          {
            song: 'Major Lazer / DJ Snake feat. MØ',
          },
        ],
      },
      {
        id: 4,
        name: 'Q_BrunoMars_LockedOutOfHeaven',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_BrunoMars_LockedOutOfHeaven.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/BrunoMars_LockedOutOfHeaven.mp3',
        correctSinger: {
          song: 'Bruno Mars',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Rihanna feat. JAY Z',
          },
          {
            song: 'Robin Thicke ft. T.I / Pharrell',
          },
          {
            song: 'Passenger',
          },
          {
            song: 'MGMT',
          },
          {
            song: 'Major Lazer / DJ Snake feat. MØ',
          },
          {
            song: 'SAINt JHN',
          },
        ],
      },
      {
        id: 5,
        name: 'Q_BeyoncéFeatJAYZ_CrazyInLove',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_BeyoncéFeatJAYZ_CrazyInLove.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/BeyoncéFeatJAYZ_CrazyInLove.mp3',
        correctSinger: {
          song: 'Beyoncé feat. JAY Z',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Twenty one pilots',
          },
          {
            song: 'AronChupa / Little Sis Nora',
          },
          {
            song: 'Bruno Mars',
          },
          {
            song: 'James Blunt',
          },
          {
            song: 'Billie Eilish / Khalid',
          },
          {
            song: 'Passenger',
          },
        ],
      },
    ],
  },
  {
    stage: 3,
    quizInfo: [
      {
        id: 1,
        name: 'Q_OliviaRodrigo_DejaVu',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_OliviaRodrigo_DejaVu.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/OliviaRodrigo_DejaVu.mp3',
        correctSinger: {
          song: 'Olivia Rodrigo',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Dido',
          },
          {
            song: 'Billie Eilish / Khalid',
          },
          {
            song: 'Capital Cities',
          },
          {
            song: 'Harry Styles',
          },
          {
            song: 'Katy Perry',
          },
          {
            song: 'Katy Perry ft. Juicy J',
          },
        ],
      },
      {
        id: 2,
        name: 'Q_TonesAndI_DanceMonkey',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_TonesAndI_DanceMonkey.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/TonesAndI_DanceMonkey.mp3',
        correctSinger: {
          song: 'Tones and I',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'James Blunt',
          },
          {
            song: 'Imagine Dragons',
          },
          {
            song: 'Adele',
          },
          {
            song: 'Lorde',
          },
          {
            song: 'Coldplay',
          },
          {
            song: 'The Chainsmokers',
          },
        ],
      },
      {
        id: 3,
        name: 'Q_BillieEilish_Bellyache',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_BillieEilish_Bellyache.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/BillieEilish_Bellyache.mp3',
        correctSinger: {
          song: 'Billie Eilish',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Katy Perry ft. Juicy J',
          },
          {
            song: 'Glass Animals',
          },
          {
            song: 'Dua Lipa',
          },
          {
            song: 'Major Lazer / DJ Snake feat. MØ',
          },
          {
            song: 'Taylor Swift',
          },
          {
            song: 'Sia',
          },
        ],
      },
      {
        id: 4,
        name: 'Q_ImagineDragons_Thunder',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_ImagineDragons_Thunder.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/ImagineDragons_Thunder.mp3',
        correctSinger: {
          song: 'Imagine Dragons',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Rihanna',
          },
          {
            song: 'James Blunt',
          },
          {
            song: 'Katy Perry ft. Juicy J',
          },
          {
            song: 'Passenger',
          },
          {
            song: 'Miley Cyrus',
          },
          {
            song: 'Taylor Swift',
          },
        ],
      },
      {
        id: 5,
        name: 'Q_twentyOnePilots_Heathens',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_twentyOnePilots_Heathens.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/twentyOnePilots_Heathens.mp3',
        correctSinger: {
          song: 'twenty one pilots',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'The Cardigans',
          },
          {
            song: 'Billie Eilish / Khalid',
          },
          {
            song: 'Katy Perry',
          },
          {
            song: 'SAINt JHN',
          },
          {
            song: 'Dido',
          },
          {
            song: 'Glass Animals',
          },
        ],
      },
    ],
  },
  {
    stage: 4,
    quizInfo: [
      {
        id: 1,
        name: 'Q_GotyeFeatKimbra_SomebodyThatIusedToKnow',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_GotyeFeatKimbra_SomebodyThatIusedToKnow.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/GotyeFeatKimbra_SomebodyThatIusedToKnow.mp3',
        correctSinger: {
          song: 'Gotye feat. Kimbra',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'P!nk ft. Nate Ruess',
          },
          {
            song: 'Adele',
          },
          {
            song: 'Tones and I',
          },
          {
            song: 'Rihanna feat. JAY Z',
          },
          {
            song: 'MGMT',
          },
          {
            song: 'Lorde',
          },
        ],
      },
      {
        id: 2,
        name: 'Q_TheWeeknd_TheHills',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_TheWeeknd_TheHills.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/TheWeeknd_TheHills.mp3',
        correctSinger: {
          song: 'The Weeknd',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Adele',
          },
          {
            song: 'Lana Del Rey',
          },
          {
            song: 'Katy Perry',
          },
          {
            song: 'Olivia Rodrigo',
          },
          {
            song: 'Sia',
          },
          {
            song: 'Sam Smith',
          },
        ],
      },
      {
        id: 3,
        name: 'Q_KatyPerry_Roar',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_KatyPerry_Roar.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/KatyPerry_Roar.mp3',
        correctSinger: {
          song: 'Katy Perry',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Billie Eilish',
          },
          {
            song: 'Gayle',
          },
          {
            song: 'Daft Punk feat. P. Williams / N. Rodgers',
          },
          {
            song: 'Taylor Swift',
          },
          {
            song: 'Adele',
          },
          {
            song: 'Olivia Rodrigo',
          },
        ],
      },
      {
        id: 4,
        name: 'Q_DuaLipa_NewRules',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_DuaLipa_NewRules.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/DuaLipa_NewRules.mp3',
        correctSinger: {
          song: 'Dua Lipa',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Imagine Dragons',
          },
          {
            song: 'Tones and I',
          },
          {
            song: 'Taylor Swift',
          },
          {
            song: 'Adele',
          },
          {
            song: 'Gayle',
          },
          {
            song: 'Coldplay',
          },
        ],
      },
      {
        id: 5,
        name: 'Q_Adele_SomeoneLikeYou',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_Adele_SomeoneLikeYou.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Adele_SomeoneLikeYou.mp3',
        correctSinger: {
          song: 'Adele',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Timbaland ft. OneRepublic',
          },
          {
            song: 'Dua Lipa',
          },
          {
            song: 'AronChupa / Little Sis Nora',
          },
          {
            song: 'Katy Perry',
          },
          {
            song: 'Harry Styles',
          },
          {
            song: 'Major Lazer / DJ Snake feat. MØ',
          },
        ],
      },
    ],
  },
  {
    stage: 5,
    quizInfo: [
      {
        id: 1,
        name: 'Q_BillieEilish_WhenThePartysOver',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_BillieEilish_WhenThePartysOver.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/BillieEilish_WhenThePartysOver.mp3',
        correctSinger: {
          song: 'Billie Eilish',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Katy Perry',
          },
          {
            song: 'Harry Styles',
          },
          {
            song: 'Fun. ft. Janelle Monáe',
          },
          {
            song: 'The Chainsmokers',
          },
          {
            song: 'Adele',
          },
          {
            song: 'Dua Lipa',
          },
        ],
      },
      {
        id: 2,
        name: 'Q_Coldplay_AskyFullOfStars',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_Coldplay_AskyFullOfStars.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Coldplay_AskyFullOfStars.mp3',
        correctSinger: {
          song: 'Coldplay',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Glass Animals',
          },
          {
            song: 'Harry Styles',
          },
          {
            song: 'Britney Spears',
          },
          {
            song: 'twenty one pilots',
          },
          {
            song: 'Olivia Rodrigo',
          },
          {
            song: 'Tones and I',
          },
        ],
      },
      {
        id: 3,
        name: 'Q_CapitalCities_SafeAndSound',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_CapitalCities_SafeAndSound.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/CapitalCities_SafeAndSound.mp3',
        correctSinger: {
          song: 'Capital Cities',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Gayle',
          },
          {
            song: 'Surfaces',
          },
          {
            song: 'Adele',
          },
          {
            song: 'OneRepublic',
          },
          {
            song: 'Imagine Dragons',
          },
          {
            song: 'Ed Sheeran',
          },
        ],
      },
      {
        id: 4,
        name: 'Q_JamesBlunt_YoureBeautiful',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_JamesBlunt_YoureBeautiful.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/JamesBlunt_YoureBeautiful.mp3',
        correctSinger: {
          song: 'James Blunt',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Katy Perry ft. Juicy J',
          },
          {
            song: 'Sam Smith',
          },
          {
            song: 'Billie Eilish',
          },
          {
            song: 'Harry Styles',
          },
          {
            song: 'Passenger',
          },
          {
            song: 'Taylor Swift',
          },
        ],
      },
      {
        id: 5,
        name: 'Q_ImagineDragons_WhateverItTakes',
        url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Q_ImagineDragons_WhateverItTakes.mp3',
        originalUrl:
          'https://victorina-tracks.s3.eu-central-1.amazonaws.com/ImagineDragons_WhateverItTakes.mp3',
        correctSinger: {
          song: 'Imagine Dragons',
          isCorrect: true,
        },
        incorrectSingers: [
          {
            song: 'Dua Lipa',
          },
          {
            song: 'James Blunt',
          },
          {
            song: 'Olivia Rodrigo',
          },
          {
            song: 'The Weeknd',
          },
          {
            song: 'Katy Perry',
          },
          {
            song: 'Billie Eilish',
          },
        ],
      },
    ],
  },
];
